import type { CmsBlock } from "@/features/shop/cms/types/cms.types";
import { mapTagStringToComponent } from "@/features/shop/cms/utils/cmsTagMapper";
import { CarouselSlide } from "@/features/shop/components/Carousel/CarouselSlide";

export type CmsCarouselSlideProps = {
  block: CmsBlock
  onHoverChange?: (hovered: boolean) => void
};

export const CmsCarouselSlide = ({ block, onHoverChange }: CmsCarouselSlideProps) => {
  const tagComponent = mapTagStringToComponent(block.tag);

  const backgroundProps = block.media_url
    ? { backgroundImage: block.media_url }
    : { backgroundColor: block.background_color };

  return (
    <CarouselSlide
      {...backgroundProps}
      tag={tagComponent}
      title={block.title}
      subtitle={block.subtitle}
      link={block.link_url}
      ctaText={block.cta_text}
      onHoverChange={onHoverChange}
    />
  );
};
